import { Routes } from '@angular/router';
import { AppLayoutData } from '@spotter/components/layout/app-layout/app-layout.component';
import { setupRoutes } from '@spotter/providers/spotter-providers';
import { HomePage } from './pages/home/home.page';


const appLayoutData: AppLayoutData = {
    site: 'tools',
    sidebarLayout: {
        sections: [
            
        ]
    }
}

export const appRoutes: Routes = [
    { path: '', component: HomePage },
    { path: 'tools/meadow-maker', loadComponent: () => import('./meadow-maker/meadow-maker.page').then(m => m.MeadowMakerPage) },
    { path: 'profile/dashboard', loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage) },
    { path: 'info', loadComponent: () => import('./pages/info/info.page').then(m => m.InfoPage) },
    {
        path: 'seagrass-spotter',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassspotter.org' }
    },
    {
        path: 'seagrassspotter',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassspotter.org' }
    },
    {
        path: 'seagrass-restorer',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassrestorer.org' }
    },
    {
        path: 'seagrassrestorer',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassrestorer.org' }
    },
    {
        path: 'seagrass-tracker',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrasstracker.org' }
    },
    {
        path: 'seagrasstracker',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrasstracker.org' }
    },
    {
        path: 'seagrass-viewer',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassviewer.org' }
    },
    {
        path: 'seagrassviewer',
        loadComponent: () => import('./pages/external-redirect/external-redirect.page').then(m => m.ExternalRedirectPage),
        data: { externalUrl: 'https://seagrassviewer.org' }
    }
];


export const routes: Routes = setupRoutes(appRoutes, appLayoutData, undefined, () => import('./app-layout.component').then(m => m.ViewerLayoutComponent));
